import HomeTargetProduct from './HomeTargetProduct';

export default HomeTargetProduct;
